import { useEffect } from "react";

const DOMAIN = "https://lederskab.nu";
const DEFAULT_IMAGE = "https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=85,format=auto/assets/22d442ab-45d9-4214-861d-1df67f744e88/anita-workshop-hero.jpg";

export default function SEO({
  title = "Lederskab.nu | Tag ansvar for eget lederskab",
  description = "Lederskab.nu tilbyder professionel ledelsesudvikling og kurser i hele Danmark med fokus på personligt ansvar, stærkere kommunikation og bæredygtig ledelse.",
  canonicalPath = "/",
  ogType = "website",
  ogImage = DEFAULT_IMAGE,
  noindex = false,
  structuredData = null,
}) {
  useEffect(() => {
    // 1. Set Title
    document.title = title;

    // 2. Helper function to update or create meta tags
    const setMetaTag = (attrName, attrValue, content) => {
      let element = document.querySelector(`meta[${attrName}="${attrValue}"]`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attrName, attrValue);
        document.head.appendChild(element);
      }
      element.setAttribute("content", content);
    };

    // Description
    if (description) {
      setMetaTag("name", "description", description);
    }

    // Robots
    setMetaTag("name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    // Canonical
    const fullCanonicalUrl = `${DOMAIN}${canonicalPath.startsWith("/") ? canonicalPath : `/${canonicalPath}`}`;
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute("href", fullCanonicalUrl);

    // Open Graph
    setMetaTag("property", "og:title", title);
    if (description) setMetaTag("property", "og:description", description);
    setMetaTag("property", "og:url", fullCanonicalUrl);
    setMetaTag("property", "og:type", ogType);
    setMetaTag("property", "og:image", ogImage);
    setMetaTag("property", "og:site_name", "Lederskab.nu");
    setMetaTag("property", "og:locale", "da_DK");

    // Twitter Cards
    setMetaTag("name", "twitter:card", "summary_large_image");
    setMetaTag("name", "twitter:title", title);
    if (description) setMetaTag("name", "twitter:description", description);
    setMetaTag("name", "twitter:image", ogImage);

    // Structured Data (JSON-LD)
    const scriptId = "dynamic-json-ld";
    let scriptElement = document.getElementById(scriptId);

    if (structuredData) {
      if (!scriptElement) {
        scriptElement = document.createElement("script");
        scriptElement.id = scriptId;
        scriptElement.type = "application/ld+json";
        document.head.appendChild(scriptElement);
      }
      scriptElement.textContent = JSON.stringify(structuredData);
    } else if (scriptElement) {
      scriptElement.remove();
    }

    return () => {
      // Clean up script on unmount if needed
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, [title, description, canonicalPath, ogType, ogImage, noindex, structuredData]);

  return null;
}
